import type { TypeCurveWorkspaceListQueryResponse } from 'types/api-responses';
import { type TypeCurvesListingFilters } from './use-type-curves-listing';
import { useListingQuery } from './hooks';

export function useTypeCurveWorkspacesListing(
  filters: TypeCurvesListingFilters,
  options: { enabled: boolean }
) {
  return useListingQuery<TypeCurveWorkspaceListQueryResponse>(
    'workspaces',
    'ws-listing',
    filters,
    options
  );
}
